import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileBend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileBend"><Path d="M13 2.5H4.5V21.5H19.5V9L13 2.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M13 3V9H19" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconFileBend;
